
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/freehand-to-figjam",
      function () {
        return require("private-next-pages/converter/freehand-to-figjam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/freehand-to-figjam"])
      });
    }
  